<template>
  <div class="ResoureBanner">
    <img
      class="img flex flex-grow pointer"
      v-for="(channel, index) in channels"
      :src="channel.pic"
      :key="index"
      @click="linkTo(channel)"
    />
  </div>
</template>

<script>
export default {
  props: {
    channels: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    linkTo({ rsType, ref }) {
      if (rsType == 'link' && ref) {
        window.open(ref);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ResoureBanner {
  margin-top: 16px;
  display: flex;
  .img {
    width: 296px;
    height: 120px;
  }
  .img + .img {
    margin-left: 16px;
  }
}
</style>
